// Baut eine chronologisch sortierte Liste von Timetable-Einträgen aus Event-, Turnier- und manuellen Daten
export function buildTimetableEntries(event, tournaments = [], customEntries = []) {
  const entries = [];
  if (event?.start_date) entries.push({ time: event.start_date, label: 'LAN Start', type: 'lan' });
  if (event?.end_date) entries.push({ time: event.end_date, label: 'LAN Ende', type: 'lan' });
  tournaments.forEach((t) => {
    if (t.start_time) entries.push({ time: t.start_time, label: t.name, type: 'tournament', tournamentId: t.id });
  });
  customEntries.forEach((e) => {
    entries.push({ time: e.time, label: e.label, type: 'custom', id: e.id });
  });
  return entries.sort((a, b) => new Date(a.time) - new Date(b.time));
}
